import { Box } from '@mui/material'
import React from 'react'

const BodyHeader = ({ children, className = '', px = '4', py = '2', gap = '2', height = 'h-screen-module-body-header' }) => {
  return (
    <Box className={`px-${px} py-${py} ${height} flex items-center gap-${gap} ${className}`}>
      {children}
    </Box>
  )
}

export default BodyHeader